import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s4_mobile h-100p px-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "s3_mobile h-100p px-2" }
const _hoisted_6 = { class: "font-normal mb-5" }
const _hoisted_7 = { class: "s4_mobile h-100p px-3" }
const _hoisted_8 = { class: "font-normal" }
const _hoisted_9 = { class: "text-2xl" }
const _hoisted_10 = { class: "s7_mobile h-100p px-5" }
const _hoisted_11 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_12 = { class: "widget-floating py-0 text-xl flex-right" }

import { inject } from 'vue';
    import { useRoute } from 'vue-router';
    import FinanceDecaissementsForm from './@forms/FinanceDecaissementsForm.vue';
    import { calculatePercentage } from '@/utils';

    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceDecaissementsDetailsView',
  setup(__props) {

    const route = useRoute();
    const BACKEND_URL = inject('BACKEND_URL');
    const startup_infos: any = route.meta.startup_infos;
    const collectivite: any = startup_infos.collectivite;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Finance / Décaissement <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Wallet</span><span class=\"btn shadow-200 white2\">Gérer les prélèvements</span><span class=\"btn shadow-200 light2 border-none\">Prélèvements / Décaissements</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s2_mobile h-100p px-7" }, [
        _createElementVNode("div", { class: "rounded-100 overflow-hidden item active" }, [
          _createElementVNode("img", {
            src: "/assets/logos/logo1.svg",
            width: "100%"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(collectivite).nom), 1),
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "C788PMKJ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(collectivite).users_count) + " / 50000 Membres", 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, [
          _cache[3] || (_cache[3] = _createTextVNode(" Date de souscription ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_9, _toDisplayString(_unref(collectivite).created_at_formatted), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, "Membres " + _toDisplayString(_unref(calculatePercentage)(_unref(collectivite).users_count, 50000, 2)) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle([{"width":"90%"}, {'width': _unref(calculatePercentage)(_unref(collectivite).users_count, 50000, 2) + '%'}])
          }, _toDisplayString(_unref(collectivite).users_count) + " / 50000 ", 5)
        ])
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createVNode(FinanceDecaissementsForm, { "startup-infos": _unref(startup_infos) }, null, 8, ["startup-infos"]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1))
  ]))
}
}

})